/**
 * Initializes focus styles on the document body by toggling CSS classes
 * based on user input method. Adds 'using-mouse' class when a mouse
 * button is pressed and 'using-keyboard' class when a keyboard key is
 * pressed, except for non-letter keys.
 */
export const initFocusStyle = () => {
    const $body = $(document.body);
    const mouseClass = 'using-mouse'
    const keyboardClass = 'using-keyboard';
    $body.on('mousedown', function () {
        const $this = $(this);
        $this.addClass(mouseClass);
        $this.removeClass(keyboardClass);
    });
    $body.on('keydown', function (event) {
        const eventKey = event.key;
        if (!eventKey) {
            return;
        }
        const key = eventKey.toLowerCase();
        const isLetter = /^[a-zA-Z0-9.]$|^enter$|^backspace$|^\s$/.test(key);
        if (!isLetter) {
            const $this = $(this);
            $this.addClass(keyboardClass);
            $this.removeClass(mouseClass);
        }
    });
}

export const fixIPhoneApostrophes = () => {
    // Targets iPhone's smart punctuation and replaces it with the regular apostrophe on all fields allowing them.
    const fieldsWithApostrophe = [
        '#Donation_Donor_FirstName',
        '#Donation_Donor_LastName',
        '#Donation_Donor_Address_FirstLine',
        '#Donation_Donor_Address_SecondLine',
        '#Donation_Donor_Address_ThirdLine',
        '#Donation_Donor_Address_PostalTown',
        '#Donation_Organisation_Firstname',
        '#Donation_Organisation_Lastname',
        '#Donation_Organisation_Address_FirstLine',
        '#Donation_Organisation_Address_SecondLine',
        '#Donation_Organisation_Address_PostalTown'
    ];
    
    fieldsWithApostrophe.forEach(function(field) {
        $(field).on('keydown', function(e) {
            if (e.keyCode === 222) {
                e.preventDefault();
                $(this)[0].value += "'";
            }
        });
        $(field).on('change', function(e) {
            $(this)[0].value = $(this)[0].value.replace(/[‘’]/g, "'");
        });
    });
}

/**
 * Attaches a click event handler to elements with the class 'back-button'.
 * When clicked, the event's default action and propagation are prevented,
 * and the browser navigates back to the previous page in history.
 */
export const handleBackButton = () => {
    if ($('.back-button').length > 0) {
        $('.back-button').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation()

            window.history.back();
        })
    }
}

/**
 * Converts the value of a postcode input field to uppercase when the input loses focus.
 * Attaches a 'blur' event listener to elements with the class 'postcode-input'.
 */
export const postCodeToUpperCase = () => {
    $('.postcode-input input').on('blur', function () {
        const pc = $(this).val();
        $(this).val(pc.toUpperCase());
    });
}

/**
 * Formats the postal code input field by trimming whitespace and converting
 * the value to uppercase when the input changes. This function is specifically
 * applied to the element with the ID 'Donation_Donor_Address_PostalCode'.
 */
export const formatPostalCode = (selector) => {
    $(selector).on('change', function () {
        $(this)[0].value = $(this)[0].value.replace(/(^\s+)|(\s+$)/g, '').toUpperCase();
    });
}

/**
 * Formats the donor's phone number by removing all spaces.
 * Attaches an event listener to the phone number input fields for donors and organizations.
 * The listener triggers on the 'change' event, ensuring the phone number is stored without spaces.
 */
export const formatDonorPhoneNumber = () => {
    $('#Donation_Donor_Phone_Number, #Donation_Organisation_Phone_Number').on('change', function () {
        $(this)[0].value = $(this)[0].value.replace(/\s/g, '');
    });
}